import { render, staticRenderFns } from "./CoResourceSelectModal.vue?vue&type=template&id=1c522d80&scoped=true&"
import script from "./CoResourceSelectModal.vue?vue&type=script&lang=ts&"
export * from "./CoResourceSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c522d80",
  null
  
)

export default component.exports